import controlsDetailsSlideOutOpenerController from "../../../controls/assets/javascript/controls-details-slide-out-opener-controller";

export default class extends controlsDetailsSlideOutOpenerController {
  get baseURL() {
    return this.data.get("url")
  }
}



// WEBPACK FOOTER //
// ./app/components/projects/assets/javascript/projects-new-project-link-controller.js